import { AppRouting } from '../enums';
import { LinkGroup } from '../models';

export const isParentLinkMatch = (currentPath: string, linkGroup: LinkGroup): boolean => {
  if (!currentPath) return false;

  const isExactPath = currentPath === linkGroup.path;

  const isProlongationPage =
    linkGroup.path.includes(AppRouting.Products) &&
    currentPath.includes(AppRouting.Prolongation);

  return isExactPath || isProlongationPage;
};
